import React from 'react';
import * as ReactDOM from 'react-dom';

import { useSelector } from 'react-redux';

import { setModalOpen } from '../../helpers/reactHelpers';
import { systemText } from '../../helpers/string';
import SlideDown from '../slideDown';
import Tabs from '../tabs';

const Modal = ({
	id,
	children,
	show,
	title,
	footer,
	close,
	tabs,
	setTab,
	tab,
	tabIcons,
	iconsPre,
	tabNames,
	tabsDisabled,
	toggleFormHelp,
	modalInModal,
	width,
	className,
	sliderContent,
}) => {
	const showFormHelp = useSelector(state => state.ui.showFormHelp);

	const [hovering, setHovering] = React.useState(true);
	const sliderLogo = React.useRef(null);

	React.useEffect(() => {
		!modalInModal && setModalOpen(show);
	}, [show]);

	React.useEffect(() => {
		return () => {
			setModalOpen(false);
		};
	}, []);

	const height = window.innerHeight * 0.9 - 115;

	if (!show) {
		return null;
	}

	const defaultFooter = (
		<button className="btn" onClick={() => close()} data-testid="modal-button-close" id="modal-button-close">
			{systemText('Admin/General/Modal/Buttons/Close')}
		</button>
	);

	const header = (
		<>
			{tabs ? (
				<Tabs
					style="clean"
					role="tabpanel"
					tab={tab}
					setTab={setTab}
					tabNames={tabNames}
					tabs={tabs}
					icons={tabIcons}
					iconsPre={iconsPre}
				/>
			) : (
				<h5 className="modal-title inline flex-grow flex-center">{title}</h5>
			)}
			<div>
				{toggleFormHelp && (
					<button
						type="button"
						className="btn btn-xs btn-link mr10 text-sm"
						data-dismiss="modal"
						data-testid="modal-help"
						onClick={toggleFormHelp}
					>
						{showFormHelp ? (
							<span data-testid="modal-help-hide">{systemText('Admin/General/Modal/Help/Hide')}</span>
						) : (
							<span data-testid="modal-help-show">{systemText('Admin/General/Modal/Help/Show')}</span>
						)}
					</button>
				)}
				{close && (
					<button
						type="button"
						className="btn btn-sm btn-default close"
						data-dismiss="modal"
						data-testid="modal-close-button"
						aria-label={systemText('Admin/General/Modal/Buttons/Close')}
						onClick={() => close()}
					>
						<span aria-hidden="true">&times;</span>
					</button>
				)}
			</div>
		</>
	);

	const model = (
		<div
			className={`modal show ${className}`}
			key={id ? `modal-${id}` : undefined}
			id="modal-window"
			data-testid={id ? `modal-${id}` : undefined}
		>
			<div className="modal-dialog" role="document" style={width ? { width: `${width}px` } : null}>
				<div className="modal-content">
					{sliderContent && (
						<SlideDown
							sliderLogo={sliderLogo}
							hovering={hovering}
							content={sliderContent}
							header={header}
							extraStyles={{ borderRadius: '2px', paddingLeft: '15px' }}
						/>
					)}
					<div className="modal-header flex">
						{sliderContent && (
							<div
								ref={sliderLogo}
								className="pointer e4-logo pl5 mr10 highlight"
								onTouchMoveCapture={() => setHovering(true)}
							/>
						)}
						{header}
					</div>
					<div className="modal-body" id="modal-body" style={{ maxHeight: `${height}px` }}>
						{children}
					</div>
					{footer !== undefined && <div className="modal-footer">{footer || defaultFooter}</div>}
				</div>
			</div>
		</div>
	);

	const dom = document.getElementById('e4-body');

	return dom ? ReactDOM.createPortal(model, dom) : model;
};

export default Modal;
